module.exports = __webpack_public_path__ + "static/img/htzqewm.4b4fdc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/htzqewm.png
// module id = ogzG
// module chunks = 1